<template>
  <ul class="mt-10" id="feature-two-list">
    <li>
      <div class="flex">
        <div class="flex-shrink-0">
          <div
            class="flex items-center justify-center h-12 w-12 rounded-md bg-green-300 text-white"
          >
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
          </div>
        </div>
        <div class="ml-4">
          <h5 class="text-lg leading-6 font-medium text-gray-900">Modernne</h5>
          <p class="mt-2 font-normal text-base leading-relaxed tracking-wide text-primary-gray">
            Oma töös kasutame samu tehnoloogiaid ja võtteid, mida kasutavad suurimad
            tehnoloogia-ettevõtted.
          </p>
        </div>
      </div>
    </li>
    <li class="mt-10">
      <div class="flex">
        <div class="flex-shrink-0">
          <div
            class="flex items-center justify-center h-12 w-12 rounded-md bg-green-300 text-white"
          >
            <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
              />
            </svg>
          </div>
        </div>
        <div class="ml-4">
          <h5 class="text-lg leading-6 font-medium text-gray-900">Kiirus</h5>
          <p class="mt-2 font-normal text-base leading-relaxed tracking-wide text-primary-gray">
            Kui koduleht ei lae 3 sekundi jooksul, lahkub lehelt üle 80% potentsiaalsetest klientidest.
            Kuna
            me teeme kõik lehed käsitsi, on meil suur kontroll lehe kiiruse üle ning me pöörame sellele
            väga suurt tähelepanu, et Teie leht oleks väga kiire.
          </p>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
import { gsap } from "gsap";
export default {
  name: "FeatureTwoList",
  computed: {
    elements: function () {
      return gsap.utils.toArray("#feature-two-list > li");
    },
  },
  methods: {
    animationsInit() {
      const scroller = this.$parent.$parent.$parent.$refs["scrollSections"];
      this.elements.forEach((element) => {
        gsap.to(element, {
          scrollTrigger: {
            trigger: element,
            scroller: scroller,
            start: "top 95%",
            end: "bottom 25%",
          },
          y: 0,
          opacity: 1,
          autoAlpha: 1,
          duration: 1,
        });
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.elements.forEach((element) => {
        gsap.set(element, {
          y: 100,
          opacity: 0,
          autoAlpha: 0,
        });
      });
      this.animationsInit();
    });
  },
};
</script>

<style scoped>
</style>
